<ion-list mode="ios" lines="none" class="ion-no-margin list-content">
    <ion-card mode="ios" color="white-grad" class="card-content">
        <ion-label mode="md" class="mpe-font-weight-500 title ion-text-center">
            {{ 'Labels.congratulations' | translate }}
        </ion-label>

        <div class="ion-text-center">
            <ion-img [src]="'Icons.cooler-welcome-image' | translate" class="img-cooler animated fadeIn fast"></ion-img>
        </div>

        <ion-label mode="md" class="mpe-font-weight-400 description ion-text-center"
            [innerHtml]="'Labels.cooler-welcome-description' | translate">
        </ion-label>

        <ion-label mode="md" class="mpe-font-weight-400 subtext ion-text-center">
            {{ 'Labels.cooler-welcome-subtext' | translate }}
        </ion-label>

        <ion-button color="tpcta" size="default" mode="md" class="button-primary" (click)="onContinue()">
            <ion-label mode="md" color="white" class="mpe-font-weight-500 button-text">
                {{ 'Buttons.cooler-request-now' | translate }}
            </ion-label>
        </ion-button>

        <ion-button size="default" mode="md" fill="clear" class="mpe-button-link-simple button-secondary"
            (click)="onDismiss()">
            <ion-label mode="md" class="secondary-text">
                {{ 'Buttons.cooler-no-thanks' | translate }}
            </ion-label>
        </ion-button>
    </ion-card>
</ion-list>